import imageCompression from 'browser-image-compression';

/**
 * Compresses an image file to WebP format before upload
 * @param {File} imageFile 
 * @param {Object} options 
 * @returns {Promise<File>}
 */
export const compressImage = async (imageFile, options = {}) => {
    if (!imageFile) return imageFile;
    
    // Default compression options
    const defaultOptions = {
        maxSizeMB: 0.5,           // 500 KB max size
        maxWidthOrHeight: 1920,   // Max resolution 1920px
        useWebWorker: true,
        fileType: 'image/webp',
        ...options
    };

    try {
        const compressedFile = await imageCompression(imageFile, defaultOptions);
        // Ensure filename ends with .webp
        const newFileName = imageFile.name.replace(/\.[^/.]+$/, "") + ".webp";
        return new File([compressedFile], newFileName, { type: 'image/webp' });
    } catch (error) {
        console.warn("Image compression failed, using original file:", error);
        return imageFile;
    }
};
